export const socketManagerPath = '/manager/socket.io/';

export const socketInputPath = '/input/socket.io/';

export const socketGameloopPath = '/gameloop/socket.io/';

export const socketSpectatePath = '/spectate/socket.io/';
